import RMSContainer from "./RMSContainer";
import RMSStore from "./RMSStore";

export default RMSStore(RMSContainer);